export const allWorks = [
  {
    id: 'work-1',
    title: '暗夜追踪',
    category: '悬疑剧集',
    categorySlug: 'suspense',
    image: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20thriller%20film%20scene%20with%20detective%20silhouette%20in%20rainy%20city%20street%20at%20night%2C%20neon%20lights%20reflecting%20on%20wet%20pavement%2C%20cinematic%20lighting%2C%20high%20contrast%2C%20film%20noir%20style%2C%20professional%20movie%20poster%20quality%2C%20clean%20background%20with%20dark%20tones&width=800&height=600&seq=work-01&orientation=landscape',
    description: '一位退役刑警被迫重返黑暗，追踪一桩尘封多年的连环案件。',
    rating: 9.2,
    year: 2026,
    episodes: 12,
    director: '陈志明',
    cast: '张译、王景春、秦昊、谭卓',
    content: `《暗夜追踪》是麻豆传媒2026年重磅推出的悬疑犯罪剧集。故事围绕退役刑警林深展开，他因一桩二十年前的连环杀人案重新被卷入黑暗漩涡。

当年那起案件的凶手至今逍遥法外，而新的受害者接连出现，作案手法与二十年前如出一辙。林深不得不与年轻女警苏晓搭档，在城市的暗夜中追寻蛛丝马迹。

随着调查深入，林深发现案件背后隐藏着一个庞大的犯罪网络，而真相远比想象中更加残酷。每一个线索都指向他曾经信任的人，每一次追踪都在挑战他的底线。

全剧12集，每集45分钟，节奏紧凑，悬念迭起。影片采用独特的暗调摄影风格，营造出压抑而迷人的视觉氛围，配以精心设计的音效，带给观众沉浸式的观影体验。`,
  },
  {
    id: 'work-2',
    title: '春风十里',
    category: '都市情感',
    categorySlug: 'romance',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20urban%20drama%20film%20scene%20with%20couple%20walking%20under%20cherry%20blossom%20trees%20in%20modern%20city%2C%20warm%20spring%20sunlight%2C%20soft%20romantic%20atmosphere%2C%20cinematic%20photography%2C%20gentle%20color%20palette%2C%20clean%20simple%20background&width=800&height=600&seq=work-02&orientation=landscape',
    description: '在繁华都市中，两个灵魂相遇相知，谱写一段温暖治愈的爱情故事。',
    rating: 8.8,
    year: 2026,
    episodes: 24,
    director: '林婉清',
    cast: '杨幂、李现、刘亦菲、陈晓',
    content: `《春风十里》是麻豆传媒2026年推出的都市情感剧集。故事发生在繁华的上海，讲述了设计师顾思远和咖啡店老板苏念之间的爱情故事。

顾思远是一位才华横溢的建筑设计师，事业有成却内心孤独。苏念经营着一家安静的街角咖啡店，用温暖的咖啡和笑容治愈着每一位客人。

一次偶然的相遇，顾思远被苏念的温暖所吸引，而苏念也在顾思远的执着中感受到久违的心动。然而，两个来自不同世界的人，面临着家庭、事业和生活方式的种种考验。

全剧24集，以细腻的镜头语言和真实的情感刻画，展现了当代都市青年在爱情与成长中的困惑与坚持。画面温暖治愈，配乐优美动人。`,
  },
  {
    id: 'work-3',
    title: '天机阁',
    category: '古装奇幻',
    categorySlug: 'fantasy',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20fantasy%20temple%20floating%20in%20clouds%20with%20mystical%20golden%20light%2C%20traditional%20architecture%20with%20magical%20elements%2C%20misty%20mountain%20landscape%2C%20cinematic%20epic%20fantasy%20film%20style%2C%20warm%20golden%20and%20crimson%20tones%2C%20clean%20background&width=800&height=600&seq=work-03&orientation=landscape',
    description: '少年意外踏入隐藏千年的天机阁，揭开尘封已久的仙界秘密。',
    rating: 9.5,
    year: 2025,
    episodes: 36,
    director: '赵无极',
    cast: '肖战、王一博、赵丽颖、刘昊然',
    content: `《天机阁》是麻豆传媒倾力打造的古装奇幻巨制，改编自同名热门小说。故事讲述了一个平凡少年意外踏入隐藏千年的天机阁，从此命运发生了翻天覆地的变化。

天机阁是上古时期遗留下来的神秘组织，掌握着天地间最深的秘密。主人公秦牧原在机缘巧合下获得了天机阁的传承，开始了一段惊心动魄的修仙之旅。

从凡人到修士，从弟子到掌门，秦牧原一步步揭开天机阁背后的惊天秘密。仙界、魔界、人界三界纷争再起，而他成为左右三界命运的关键人物。

全剧36集，采用顶级的视觉特效和精美的服化道设计。每一帧画面都经过精心打磨，宏大的场景和细腻的情感刻画相得益彰，为观众呈现了一个磅礴壮丽的东方奇幻世界。`,
  },
  {
    id: 'work-4',
    title: '极限追捕',
    category: '动作警匪',
    categorySlug: 'action',
    image: 'https://readdy.ai/api/search-image?query=Intense%20action%20police%20chase%20film%20scene%20on%20city%20highway%20with%20dramatic%20lighting%2C%20fast%20paced%20thriller%20atmosphere%2C%20professional%20movie%20cinematography%2C%20warm%20amber%20and%20dark%20tones%2C%20clean%20simple%20background&width=800&height=600&seq=work-04&orientation=landscape',
    description: '精英特警小组与跨国犯罪集团的生死较量，每一秒都是惊心动魄。',
    rating: 8.9,
    year: 2026,
    episodes: 16,
    director: '周浩宇',
    cast: '吴京、张涵予、彭于晏、张钧甯',
    content: `《极限追捕》是麻豆传媒2026年推出的动作警匪大片。由金牌动作导演周浩宇执导，实力派演员阵容倾情出演。

故事围绕精英特警小组"猎鹰"展开，他们在一次例行任务中意外发现了一个横跨多国的犯罪网络。为了摧毁这个庞大的犯罪帝国，小组成员们踏上了一段充满危险的追捕之旅。

从繁华都市到边境密林，从高空追车到水下搏斗，每一场动作戏都经过精心设计和反复排练。影片采用实景拍摄为主，CGI辅助的方式，力求给观众最真实震撼的视觉体验。

全剧16集，节奏紧凑，场场火爆。不仅有令人肾上腺素飙升的动作场面，更有深入人心的情感刻画，展现了特警队员们在职责与情感之间的挣扎与抉择。`,
  },
  {
    id: 'work-5',
    title: '迷雾深渊',
    category: '悬疑剧集',
    categorySlug: 'suspense',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20foggy%20forest%20scene%20with%20detective%20holding%20flashlight%20searching%20for%20clues%2C%20eerie%20atmosphere%2C%20cinematic%20thriller%20lighting%2C%20dark%20green%20and%20amber%20tones%2C%20professional%20film%20quality%2C%20clean%20background&width=800&height=600&seq=work-05&orientation=landscape',
    description: '一座与世隔绝的山村，七个人相继离奇死亡，真相隐藏在浓雾之中。',
    rating: 9.0,
    year: 2025,
    episodes: 10,
    director: '孙浩然',
    cast: '段奕宏、邓超、周迅、黄渤',
    content: `《迷雾深渊》是麻豆传媒2025年推出的悬疑力作。故事发生在一座常年被浓雾笼罩的偏远山村。

七名游客在一次户外探险中迷失方向，来到这座被称为"迷雾村"的诡异之地。村民们对外来者保持着诡异的沉默，而接二连三的死亡事件让每个人都陷入了恐惧。

资深警探方毅受命调查此案，却发现每一个死者都似乎与二十年前的一桩灭门惨案有着千丝万缕的联系。随着调查的深入，方毅发现自己也成为了这场死亡游戏的一部分。

全剧10集，每集60分钟。采用非线性叙事手法，层层递进地揭示真相。阴郁的氛围营造和精妙的情节设计，让观众在最后一刻才恍然大悟。`,
  },
  {
    id: 'work-6',
    title: '你好旧时光',
    category: '都市情感',
    categorySlug: 'romance',
    image: 'https://readdy.ai/api/search-image?query=Nostalgic%20warm%20scene%20of%20young%20couple%20in%20vintage%20cafe%20with%20soft%20golden%20afternoon%20light%2C%20romantic%20retro%20atmosphere%2C%20cinematic%20film%20style%2C%20warm%20amber%20and%20cream%20tones%2C%20clean%20simple%20background&width=800&height=600&seq=work-06&orientation=landscape',
    description: '多年后重逢，曾经错过的缘分能否重新续写？一部温暖人心的情感佳作。',
    rating: 8.7,
    year: 2026,
    episodes: 20,
    director: '陈思诚',
    cast: '周冬雨、易烊千玺、倪妮、朱一龙',
    content: `《你好旧时光》是麻豆传媒2026年推出的一部温暖治愈的情感剧集。故事横跨十年时光，讲述了两个人在青春岁月中错过，又在多年后重逢的故事。

高中时代的林小满和陆子昂是最要好的朋友，彼此暗生情愫却从未表白。高考后各奔东西，一别就是十年。当他们在母校百年校庆上重逢时，曾经的情愫再次被唤醒。

然而十年的时光改变了太多。林小满成为了一名独立的设计师，而陆子昂已经是知名互联网公司的技术总监。他们各自经历了不同的人生，却都在心底为对方留着一个位置。

全剧20集，采用双时间线叙事，在过去与现在之间穿梭。温暖治愈的影像风格和细腻动人的情感表达，让观众在观剧过程中不断回忆起自己的青春岁月。`,
  },
  {
    id: 'work-7',
    title: '龙门客栈',
    category: '古装奇幻',
    categorySlug: 'fantasy',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20inn%20with%20lanterns%20in%20desert%20setting%2C%20mystical%20martial%20arts%20atmosphere%2C%20warm%20candlelight%20and%20dark%20shadows%2C%20cinematic%20wuxia%20film%20style%2C%20golden%20and%20deep%20red%20tones%2C%20clean%20background&width=800&height=600&seq=work-07&orientation=landscape',
    description: '大漠孤烟，龙门客栈。各路英雄汇聚于此，一场江湖风暴即将来临。',
    rating: 9.3,
    year: 2025,
    episodes: 30,
    director: '徐克',
    cast: '张震、章子怡、王宝强、倪大红',
    content: `《龙门客栈》是麻豆传媒联合顶级制作团队打造的古装武侠奇幻巨作。以经典IP为蓝本，进行了全新的演绎和拓展。

故事发生在明朝末年的大漠边陲。龙门客栈作为连接中原与西域的咽喉要道，汇聚了三教九流、各色人等。老板娘金镶玉表面经营客栈，实则是江湖中闻名遐迩的情报贩子。

当朝廷密使、江湖侠客、西域商人和神秘组织在龙门客栈相遇，一场牵动天下格局的风暴就此展开。忠诚与背叛、爱情与仇恨、江湖与庙堂，每个人都被卷入这场无法逃避的漩涡。

全剧30集，融合了传统武侠和奇幻元素。实景拍摄的壮丽大漠风光与精心设计的武打场面相得益彰，呈现出一个波澜壮阔的江湖世界。`,
  },
  {
    id: 'work-8',
    title: '爆笑办公室',
    category: '喜剧剧场',
    categorySlug: 'comedy',
    image: 'https://readdy.ai/api/search-image?query=Bright%20cheerful%20modern%20office%20comedy%20scene%20with%20colorful%20decor%20and%20funny%20colleagues%2C%20warm%20natural%20lighting%2C%20joyful%20professional%20atmosphere%2C%20clean%20simple%20background%20with%20warm%20yellow%20and%20green%20tones&width=800&height=600&seq=work-08&orientation=landscape',
    description: '一家小型广告公司的日常爆笑故事，每集都是欢乐源泉。',
    rating: 8.5,
    year: 2026,
    episodes: 40,
    director: '宁浩',
    cast: '沈腾、马丽、艾伦、常远',
    content: `《爆笑办公室》是麻豆传媒2026年推出的轻松喜剧系列。由喜剧大师宁浩监制，开心麻花核心团队倾情出演。

故事围绕"创意无限广告公司"的一群性格各异的员工展开。有脑洞大开却永远踩雷的创意总监、严谨过头让人崩溃的财务主管、还有永远在摸鱼却总能蒙混过关的设计师。

每一集围绕一个广告项目展开，从奇葩甲方到离谱需求，从办公室政治到职场恋情，各种爆笑情节层出不穷。在欢笑之余，也真实反映了当代都市白领的职场生活。

全剧40集，每集25分钟，节奏轻快，笑点密集。是观众释放压力、收获快乐的绝佳选择。`,
  },
  {
    id: 'work-9',
    title: '极地征途',
    category: '纪录纪实',
    categorySlug: 'documentary',
    image: 'https://readdy.ai/api/search-image?query=Stunning%20documentary%20footage%20of%20polar%20landscape%20with%20icebergs%20and%20northern%20lights%2C%20professional%20nature%20cinematography%2C%20crisp%20cold%20atmosphere%2C%20clean%20simple%20background%20with%20icy%20blue%20and%20white%20tones&width=800&height=600&seq=work-09&orientation=landscape',
    description: '跟随科考队深入南极，记录极地生态的壮美与脆弱。',
    rating: 9.6,
    year: 2025,
    episodes: 6,
    director: '陆川',
    cast: '旁白：姜文',
    content: `《极地征途》是麻豆传媒联合国家地理团队打造的高端自然纪录片。历时两年拍摄，行程超过三万公里，深入南极冰原和北极圈，记录下极地生态系统的壮美与脆弱。

影片以4K超高清摄影机拍摄，捕捉了极地最震撼人心的画面：广袤无垠的冰原、绚烂多彩的极光、憨态可掬的企鹅群、以及正在消融的冰川。

同时，纪录片也关注气候变化对极地生态的影响。通过科学家们的实地研究和数据记录，向观众展示全球变暖正在如何改变这片地球上最后的净土。

全片6集，每集50分钟。特邀姜文配音，以沉稳有力的声音为观众讲述极地的故事。这不仅是一部自然纪录片，更是一封写给地球的情书。`,
  },
  {
    id: 'work-10',
    title: '铁血营救',
    category: '动作警匪',
    categorySlug: 'action',
    image: 'https://readdy.ai/api/search-image?query=Intense%20military%20rescue%20mission%20scene%20with%20special%20forces%20in%20urban%20combat%2C%20dramatic%20explosion%20lighting%2C%20cinematic%20action%20film%20style%2C%20warm%20amber%20and%20dark%20contrast%2C%20clean%20background&width=800&height=600&seq=work-10&orientation=landscape',
    description: '当人质危在旦夕，特战小队必须在48小时内完成不可能的任务。',
    rating: 9.1,
    year: 2026,
    episodes: 8,
    director: '林超贤',
    cast: '张涵予、彭于晏、黄景瑜、杜江',
    content: `《铁血营救》是麻豆传媒2026年出品的军事动作剧集。由著名动作导演林超贤执导，再现了中国特战队员英勇无畏的战斗精神。

故事基于真实事件改编。一队中国工程师在海外被武装分子劫持，特战小队"龙焱"临危受命，必须在48小时内完成营救任务。时间紧迫，敌众我寡，每一步都走在刀尖上。

影片真实还原了现代特种作战的战术细节，从情报搜集到制定方案，从渗透潜入到火力突击，每一个环节都经过军事顾问的严格把关。

全剧8集，采用电影级制作标准。震撼的爆炸场面、激烈的枪战对决、以及队员之间生死与共的兄弟情谊，构成了一部令人热血沸腾的军事动作大片。`,
  },
  {
    id: 'work-11',
    title: '家有萌宠',
    category: '喜剧剧场',
    categorySlug: 'comedy',
    image: 'https://readdy.ai/api/search-image?query=Cute%20pets%20in%20cozy%20home%20setting%20with%20warm%20natural%20light%2C%20funny%20animal%20behavior%2C%20bright%20cheerful%20comedy%20atmosphere%2C%20clean%20simple%20background%20with%20warm%20pastel%20tones&width=800&height=600&seq=work-11&orientation=landscape',
    description: '一个宠物爱好者和五只性格各异的萌宠之间的欢乐日常。',
    rating: 8.3,
    year: 2025,
    episodes: 36,
    director: '贾玲',
    cast: '贾玲、张小斐、许君聪、何欢',
    content: `《家有萌宠》是麻豆传媒推出的轻松治愈喜剧。讲述了一个独居女孩和她收养的五只流浪动物之间的温馨日常。

女主角林可可是一位动物爱好者，她在自己的小公寓里收养了五只被遗弃的宠物：一只傲娇的波斯猫、一只忠诚的金毛犬、一只话痨的鹦鹉、一只调皮的仓鼠和一只高冷的蜥蜴。

五只宠物各有各的性格，每天都会闹出各种啼笑皆非的事情。在照顾这些小生命的过程中，林可可也找到了生活的意义和快乐。

全剧36集，每集30分钟。温暖治愈的风格加上搞笑幽默的情节，是适合全家人一起观看的优质喜剧。`,
  },
  {
    id: 'work-12',
    title: '丝路回响',
    category: '纪录纪实',
    categorySlug: 'documentary',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Silk%20Road%20landscape%20with%20camel%20caravan%20and%20historical%20architecture%2C%20golden%20desert%20sunset%2C%20documentary%20cinematography%20style%2C%20warm%20earth%20tones%2C%20clean%20simple%20background&width=800&height=600&seq=work-12&orientation=landscape',
    description: '重走丝绸之路，探寻千年文明的辉煌与传承。',
    rating: 9.4,
    year: 2024,
    episodes: 10,
    director: '张艺谋',
    cast: '旁白：陈道明',
    content: `《丝路回响》是麻豆传媒出品的大型历史文化纪录片，耗时三年拍摄，跨越八个国家，全面展现丝绸之路的辉煌历史与当代风貌。

从古都长安出发，途经敦煌、喀什、撒马尔罕、巴格达，最终抵达罗马。影片不仅记录了沿途壮美的自然风光和珍贵的历史遗迹，更深入探访了当地人民的生活，展现丝路文明在今天的新生。

每一集都聚焦丝路上的一个重要节点城市，通过历史重现、专家访谈和实地拍摄相结合的方式，生动还原了两千年来东西方文明在这条路上交流碰撞的壮丽画卷。

全片10集，每集55分钟。由张艺谋担任艺术指导，陈道明倾情配音。这是麻豆传媒迄今为止投资最大、制作周期最长的一部纪录片作品。`,
  },
];

export const aboutContent = {
  brandIntro: {
    title: '关于麻豆传媒',
    subtitle: '专注优质影视内容制作与发行的专业传媒机构',
    content: `麻豆传媒成立于2018年，是一家集影视内容制作、发行、版权运营于一体的综合性传媒机构。公司总部位于北京，在上海、广州、成都设有分支机构，团队规模超过300人。

自成立以来，麻豆传媒始终秉承"内容为王，品质至上"的核心理念，致力于为全球华语观众提供高质量的影视娱乐内容。公司拥有一支由资深制片人、导演、编剧和后期制作人员组成的专业团队，具备从创意开发到制作发行的全产业链能力。

目前，麻豆传媒已累计制作发行超过500部影视作品，涵盖悬疑、情感、奇幻、动作、喜剧、纪录片等多个类型，平台注册用户突破2000万。多部作品在海内外获得重要奖项，赢得了业界和观众的广泛认可。`,
    image: 'https://readdy.ai/api/search-image?query=Modern%20professional%20film%20production%20office%20interior%20with%20creative%20team%20collaborating%2C%20warm%20ambient%20lighting%2C%20elegant%20corporate%20atmosphere%2C%20clean%20minimalist%20design%2C%20warm%20golden%20and%20cream%20tones%2C%20professional%20photography&width=1200&height=800&seq=about-brand&orientation=landscape',
  },
  milestones: [
    { year: '2018', event: '麻豆传媒正式成立，推出首部原创网剧《深夜咖啡馆》' },
    { year: '2019', event: '平台注册用户突破100万，完成A轮融资' },
    { year: '2020', event: '推出会员服务体系，上线50+独家原创内容' },
    { year: '2021', event: '获得"年度最佳内容平台"奖项，注册用户突破500万' },
    { year: '2022', event: '成立海外事业部，拓展东南亚及欧美市场' },
    { year: '2023', event: '原创剧集《天机阁》获得国际艾美奖提名，用户突破1500万' },
    { year: '2024', event: '纪录片《丝路回响》获得金鸡奖最佳纪录片，启动AI影视技术实验室' },
    { year: '2025', event: '平台内容总量突破500部，全球注册用户突破2000万' },
  ],
  testimonials: [
    {
      name: '李明',
      role: '资深影视评论人',
      content: '麻豆传媒在内容品质上的坚持令人钦佩。从剧本打磨到后期制作，每一个环节都能看到团队的用心。尤其是近两年的原创剧集，无论是叙事手法还是视觉呈现，都达到了行业领先水平。',
    },
    {
      name: '王芳',
      role: '金鸡奖评审委员',
      content: '作为评审，我见证了麻豆传媒的快速成长。他们不追逐短期流量，而是沉下心来打磨每一部作品，这种对品质的执着在当今行业环境中尤为珍贵。《天机阁》和《丝路回响》都展现了极高的制作水准。',
    },
    {
      name: '张伟',
      role: '长期订阅会员',
      content: '我是从2019年开始订阅的资深会员，可以说见证了麻豆传媒的每一步成长。最打动我的是他们对用户反馈的重视——每次提的建议都能在下个版本中看到改进。内容质量也没话说，物超所值。',
    },
  ],
  contact: {
    address: '北京市朝阳区建国路88号SOHO现代城A座15层',
    phone: '400-888-6666',
    email: 'contact@madoumedia.com',
    wechat: '麻豆传媒官方号',
    weibo: '@麻豆传媒',
  },
};